import { cqrs } from '@faro/http-clients';
import { StudyContributor, toStudyContributor } from '@faro/study-designer-model';

/**
 * Client responsible for managing study contributors
 */
export const studyContributorClient = cqrs<StudyContributor>(
    '/api/study-designer/enumerated-values/study-contributors',
    toStudyContributor
).listableEntityClient();
